import axios from "axios";

const getAllSlides = async () => {
  return await axios({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/slides`,
  });
};
export { getAllSlides };
